import { render, staticRenderFns } from "./Guia.vue?vue&type=template&id=5175427c&scoped=true&"
import script from "./Guia.vue?vue&type=script&lang=js&"
export * from "./Guia.vue?vue&type=script&lang=js&"
import style0 from "./Guia.vue?vue&type=style&index=0&id=5175427c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5175427c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/joeldev/Developer/clientes/aduanas-pty/front-transit/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VContainer,VFlex,VIcon,VLayout})
